module.exports = __webpack_public_path__ + "static/media/binary.82ddc128.svg";